<button ndt-tertiary-button type="button" (click)="goBack()">
  <app-icon name="arrow-left"></app-icon><ng-container i18n>Wróć</ng-container>
</button>
